import ReactMarkdown from "react-markdown";
import ChatProof from "./ChatProof";

const userChipClasses =
    "self-end bg-white text-heading py-1.5 px-3 rounded-[calc(var(--spacing)*2.5)] " +
    "text-[calc(var(--spacing)*3.25)] leading-[calc(var(--spacing)*4.5)] shadow-[0_1px_2px_rgba(16,24,40,0.15)] " +
    "max-w-full break-words " +
    "[&_p]:m-0! [&_p]:mb-1!";

const botBubbleClasses =
    "bg-primary-surface border border-primary-surface rounded-[calc(var(--spacing)*2.5)] py-3 px-3.5 " +
    "shadow-[0_1px_0_rgba(16,24,40,0.04),0_2px_4px_rgba(16,24,40,0.06)] " +
    "text-sm leading-[1.55] text-heading max-w-full break-words " +
    "[&_p]:m-0! [&_p]:mb-1!";

const errorClasses = "bg-danger-surface! text-danger! border border-danger!";

const linkClasses =
    "inline-block mt-0.5 text-primary underline text-[calc(var(--spacing)*3.25)]";

const listClasses = "mt-2 mb-3 mx-0 pl-5.5 list-disc [&_li]:my-1.5";

const strongClasses = "font-semibold";

const footnoteClasses =
    "inline-flex items-center justify-center w-4 h-4 mx-1.5 my-0 " +
    "text-[calc(var(--spacing)*2.75)] font-semibold text-heading bg-primary-surface " +
    "border border-border-light rounded-full align-middle";

export default function ChatMessageBox({ message }) {
    const isUser = message.author === "user";
    const isError = message.isError;

    const bubbleClass = `${isUser ? userChipClasses : botBubbleClasses} ${isError ? errorClasses : ""}`;

    return (
        <div className={bubbleClass}>
            <ReactMarkdown
                components={{
                    a: (props) => <a className={linkClasses} {...props} />,
                    ul: (props) => <ul className={listClasses} {...props} />,
                    strong: (props) => <p className={strongClasses} {...props} />,
                    sup: (props) => <span className={footnoteClasses} {...props} />,
                }}
            >
                {message?.message}
            </ReactMarkdown>
            <ChatProof message={message}/>
        </div>
    );
}
